import FingerprintJS from '@fingerprintjs/fingerprintjs';

let cachedDeviceId: string | null = null
let fingerprintPromise: Promise<string> | null = null
// Generate or retrieve device ID
async function getDeviceId(): Promise<string> {
  // Return cached value if exists
  if (cachedDeviceId) {
    return cachedDeviceId
  }
  
  // If fingerprint is being calculated, wait for it
  if (fingerprintPromise) {
    return fingerprintPromise
  }
  
  // Calculate fingerprint only once
  fingerprintPromise = (async () => {
    try {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      cachedDeviceId = result.visitorId
      return cachedDeviceId
    } catch (error) {
      console.error('Error getting device ID:', error)
      // Fallback to random ID if fingerprinting fails
      cachedDeviceId = crypto.randomUUID()
      return cachedDeviceId
    } finally {
      fingerprintPromise = null
    }
  })()
  
  return fingerprintPromise
}


export default getDeviceId